import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faPhone, 
  faCalendarDays,
  faLocationPin,
  faLocationDot, 
  faPeopleGroup, 
  faSuitcaseRolling, 
  faCartFlatbedSuitcase 
} from '@fortawesome/free-solid-svg-icons';

import { 
    faFacebook, 
    faInstagram, 
    faLinkedin,
    faXTwitter
  } from '@fortawesome/free-brands-svg-icons';

const Footer2Section = () => {
    return (
        <Box
            sx={{
                height: '40px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0',
                backgroundColor: '#222222',
            }}
        >
            <Container sx={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
                    <Typography sx={{color: '#ffffff', fontSize: '14px'}}>
                        Copyright © 2025 Sigmatiqa Ltd. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer2Section;